/**
 * API client for usage / spend analytics endpoints.
 * Routes: /api/mgmt/usage
 */

import { apiFetch } from './client';

export interface UsageSummary {
  totalSpend: number;
  totalTokens: number;
  totalRequests: number;
  period: string;
  breakdown?: ModelBreakdown[];
  dailySpend?: DailySpend[];
}

export interface ModelBreakdown {
  model: string;
  spend: number;
  tokens: number;
  requests: number;
}

export interface DailySpend {
  date: string;
  spend: number;
}

export interface UserUsage {
  username: string;
  totalSpend: number;
  totalTokens: number;
  totalRequests: number;
  dailySpend: DailySpend[];
}

export interface ProjectUsage {
  projectId: string;
  totalSpend: number;
  totalTokens: number;
  totalRequests: number;
  dailySpend: DailySpend[];
}

export async function getUsageSummary(token: string, days?: number): Promise<UsageSummary> {
  const query = days ? `?days=${days}` : '';
  return apiFetch<UsageSummary>(`/api/mgmt/usage/summary${query}`, token);
}

export async function getUserUsage(username: string, token: string): Promise<UserUsage> {
  return apiFetch<UserUsage>(
    `/api/mgmt/usage/users/${encodeURIComponent(username)}`,
    token,
  );
}

export async function getProjectUsage(projectId: string, token: string): Promise<ProjectUsage> {
  return apiFetch<ProjectUsage>(
    `/api/mgmt/usage/projects/${encodeURIComponent(projectId)}`,
    token,
  );
}
